// Note the below line will import and run the Summernote Add Class Extension
// import SummernoteAddClass from './summernote-add-class.js'
/**
 * Content
 */
export const Content = (function () {

  var init =  function () {   
    // Find all the elements with `myds-content` and init summernote
    $('.myds-content-textarea').each(function () {
      // Initialise Summernote with the setings on the HTML
      $(this).summernote(parseSettings(this));
    });
        
  }
  /**
   * Public
   * Get the content from a summernote editor by the id it was given
   * @param {} id 
   */
  function getContent( id ) {
    var element = $(`#myds-content-textarea-${id}`);
    if(!element){
        console.error(`Summernote editor with ID ${id} not found.`); 
    }
    return $(element).summernote('code');
  }
  /**
   * Public
   * Get the content from a summernote editor by the id it was given
   * @param {} id 
   */
  function setContent( id, content ) {
    var element = $(`#myds-content-textarea-${id}`);
    if(!element){
        console.error(`Summernote editor with ID ${id} not found.`); 
    }
    return $(element).html('code',content);
  }
  /**
   * If there is a data-{settings} attribute on the html, add it to the
   * settings object that will be passed to the summernote init
   * @param {*} element 
   */
  function parseSettings(element) {
    var settings = {};
    settings['toolbar'] = toolbar;
    settings['addclass'] = classTags;
    // Cycle over each attribute on the element
    for (var i = 0; i < element.attributes.length; i++) {
        // Store reference to current attr
        var attr = element.attributes[i];
        // If attribute nodeName starts with 'data-'
        if (/^data-/.test(attr.nodeName)) {
            // Log its name (minus the 'data-' part), and its value
            settings[attr.nodeName.replace(/^data-/, '')] = attr.nodeValue
        }
    }
    return settings;
  }
  
  const toolbar = [
    ['style', ['style']],
    ['custom', ['addclass']],
    ['font-style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
    // ['font', ['fontname']],
    // ['font-size',['fontsize']],
    // ['font-color', ['color']],
    ['para', ['ul', 'ol', 'paragraph']],
    ['table', ['table']],
    ['insert', ['link', 'picture', 'video', 'hr']],
    ['misc', ['fullscreen', 'codeview', 'help']]
  ];
  const classTags = {
    classTags: [
      {title:"None","value":""},
      {title:"Primary","value":"text-primary"},
      {title:"Secondary","value":"text-secondary"},
      {title:"Danger","value":"text-danger"},
      {title:"Muted","value":"text-muted"},
      {title:"Warning","value":"text-warning"},
      {title:"Success","value":"text-success"}
    ]
  };

  return {
    init: init,
    getContent: getContent,
    setContent: setContent
  }


}());


